import { type RouteObject } from 'react-router-dom';

import { ROUTES_PATH } from '@/constants/routes.constants';

export const FullIpLabelsRoutes: RouteObject[] = [
  {
    path: ROUTES_PATH.fullIpLabelList,
    children: [
      { index: true, lazy: () => import('./full-ip-label-list') },
      { path: ':id', lazy: () => import('./full-ip-label-detail') },
      { path: 'new', lazy: () => import('./full-ip-label-new') },
    ],
  },
];
